import { getRoute } from '../utils/get-route';
export var getRouteActionResult = function (router) { return function (name) {
    var routes = router.getDependencies().routes;
    var route = getRoute(name, routes);
    return route.actionResult || null;
}; };
